module.exports = __webpack_public_path__ + "img/menu.872edf35.svg";